export const BroadcastType = Object.freeze({
    MATCH: 'match',
    RANKINGS: 'rankings',
    NEW_GAME: 'new_game',
    GAME_COMPLETED: 'game_completed',
    SKIP_TO_FINALS: 'skip_to_finals'
});
